import { Controller } from "@hotwired/stimulus"

// Sends a rich-text field's content to the résumé AI polish/grammar endpoint
// and replaces the field with the result (then fires autosave). Lives on the
// same element as the rich-text controller; targets the sibling contenteditable.
export default class extends Controller {
  static values = { polishUrl: String, grammarUrl: String, kind: String }

  polish()  { this.run(this.polishUrlValue) }
  grammar() { this.run(this.grammarUrlValue) }

  run(url) {
    const editable = this.element.querySelector("[contenteditable]")
    if (!editable || !url) return
    const text = editable.innerHTML
    if (!text.replace(/<[^>]*>/g, "").trim()) return
    if (this.busy) return
    this.busy = true
    this.element.classList.add("rb-ai-busy")
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(url, {
      method: "POST",
      headers: { "X-CSRF-Token": token, "Content-Type": "application/json", "Accept": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ text: text, kind: this.kindValue })
    })
      .then((r) => r.json())
      .then((data) => {
        if (data && data.ok && data.text) {
          editable.innerHTML = data.text
          editable.dispatchEvent(new Event("input", { bubbles: true }))
        } else if (data && data.error) {
          window.alert(data.error)
        }
      })
      .catch(() => {})
      .finally(() => { this.busy = false; this.element.classList.remove("rb-ai-busy") })
  }
}
